const GET_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL = 'GET_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL';
const SET_IS_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL = 'SET_IS_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL';
const SET_ASSET_APPROVAL_DATA = 'SET_ASSET_APPROVAL_DATA'

const GET_TRANSFER_APPROVER_ACTIONS_DATA = 'GET_TRANSFER_APPROVER_ACTIONS_DATA';
const SET_TRANSFER_APPROVER_ACTIONS_DATA = 'SET_TRANSFER_APPROVER_ACTIONS_DATA';

const SET_TRANSFER_ORDER_APPROVAL_REQUEST = 'SET_TRANSFER_ORDER_APPROVAL_REQUEST';
const SET_TRANSFER_APPROVAL_REQUEST_OPTION_ = 'SET_TRANSFER_APPROVAL_REQUEST_OPTION_'

export
{
    GET_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL,
    SET_IS_TRANSFER_ITEM_AND_ORDER_LEVEL_APPROVAL,
    GET_TRANSFER_APPROVER_ACTIONS_DATA,
    SET_TRANSFER_APPROVER_ACTIONS_DATA,
    SET_TRANSFER_ORDER_APPROVAL_REQUEST,
    SET_TRANSFER_APPROVAL_REQUEST_OPTION_,
    SET_ASSET_APPROVAL_DATA
};
